import { SimpleTreeView, TreeItem } from '@mui/x-tree-view'
import { Box, Stack } from '@mui/material'
import React from 'react'
import { ButtonsShowcase } from '../../componentshowcase/ButtonsShowcase'
import { createFileRoute } from '@tanstack/react-router'
import { ButtonGroupShowcase } from '../../componentshowcase/ButtonGroupShowcase'
import { CheckboxShowcase } from '../../componentshowcase/CheckboxShowcase'
import { TypographyShowcase } from '../../componentshowcase/TypographyShowcase'
import AlertShowcase from '../../componentshowcase/AlertShowcase'
import DialogShowcase from '../../componentshowcase/DialogShowcase'
import { ChipShowcase } from '../../componentshowcase/ChipShowcase'
import { TextFieldShowcase } from '../../componentshowcase/TextFieldShowcase'
import { SelectShowcase } from '../../componentshowcase/SelectShowcase'
import { SwitchShowcase } from '../../componentshowcase/SwitchShowcase'
import { RadioGroupShowcase } from '../../componentshowcase/RadioGroupShowcase'
import { AutocompleteShowcase } from '../../componentshowcase/AutocompleteShowcase'
import { BadgeShowcase } from '../../componentshowcase/BadgeShowcase'
import { TableShowcase } from '../../componentshowcase/TableShowcase'
import ProgressShowcase from '../../componentshowcase/ProgressShowcase'
import EntityTypeListShowcase from '../../componentshowcase/EntityTypeListShowcase'
import AssumptionShowcase from '../../componentshowcase/AssumptionShowcase'
import { ToggleButtonShowcase } from '../../componentshowcase/ToggleButtonShowcase'

export const Route = createFileRoute('/_auth/components')({
  component: ComponentShowcase,
})

function ComponentShowcase() {
  const [lastSelectedItem, setLastSelectedItem] = React.useState<string | null>(null)

  const handleItemSelectionToggle = (
    _event: React.SyntheticEvent | null,
    itemId: string,
    isSelected: boolean,
  ) => {
    if (isSelected) {
      setLastSelectedItem(itemId)
    }
  }
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        gap: 3,
      }}
    >
      <Box
        sx={{
          padding: 2,
          width: 250,
        }}
      >
        <SimpleTreeView onItemSelectionToggle={handleItemSelectionToggle}>
          <TreeItem itemId="components" label="Inputs">
            <TreeItem itemId="autocomplete" label="Autocomplete" />
            <TreeItem itemId="buttons" label="Buttons" />
            <TreeItem itemId="button-group" label="Button Group" />
            <TreeItem itemId="checkbox" label="Checkbox" />
            <TreeItem itemId="radio-group" label="Radio Group" />
            <TreeItem itemId="select" label="Select" />
            <TreeItem itemId="switch" label="Switch" />
            <TreeItem itemId="table" label="Table" />
            <TreeItem itemId="textfield" label="Text Field" />
            <TreeItem itemId="toggle-button" label="Toggle Button" />
          </TreeItem>
          <TreeItem itemId="data" label="Data Display">
            <TreeItem itemId="badge" label="Badge" />
            <TreeItem itemId="chip" label="Chip" />
            <TreeItem itemId="typography" label="Typography" />
          </TreeItem>
          <TreeItem itemId="feedback" label="Feedback">
            <TreeItem itemId="alert" label="Alert" />
            <TreeItem itemId="dialog" label="Dialog" />
            <TreeItem itemId="progress" label="Progress" />
          </TreeItem>
          <TreeItem itemId="mercatus" label="Mercatus">
            <TreeItem itemId="assumption" label="Asumptions" />
            <TreeItem itemId="entitytype" label="EntityType list" />
            <TreeItem itemId="grid-tabs" label="GridView tabs" />
          </TreeItem>
        </SimpleTreeView>
      </Box>
      <Stack
        style={{ height: '100%', width: '100%', overflowY: 'scroll' }}
        sx={{
          alignItems: 'center',
          padding: 2,
        }}
      >
        <Box
          sx={{
            minWidth: '85ch',
            maxWidth: '120ch',
            height: 'calc(100vh - 76px);',
          }}
        >
          <div style={{ paddingBottom: '50px' }}>
            {lastSelectedItem === 'assumption' && <AssumptionShowcase />}
            {lastSelectedItem === 'autocomplete' && <AutocompleteShowcase />}
            {lastSelectedItem === 'badge' && <BadgeShowcase />}
            {lastSelectedItem === 'buttons' && <ButtonsShowcase />}
            {lastSelectedItem === 'button-group' && <ButtonGroupShowcase />}
            {lastSelectedItem === 'checkbox' && <CheckboxShowcase />}
            {lastSelectedItem === 'chip' && <ChipShowcase />}
            {lastSelectedItem === 'radio-group' && <RadioGroupShowcase />}
            {lastSelectedItem === 'table' && <TableShowcase />}
            {lastSelectedItem === 'typography' && <TypographyShowcase />}
            {lastSelectedItem === 'alert' && <AlertShowcase />}
            {lastSelectedItem === 'dialog' && <DialogShowcase />}
            {lastSelectedItem === 'textfield' && <TextFieldShowcase />}
            {lastSelectedItem === 'select' && <SelectShowcase />}
            {lastSelectedItem === 'switch' && <SwitchShowcase />}
            {lastSelectedItem === 'progress' && <ProgressShowcase />}
            {lastSelectedItem === 'entitytype' && <EntityTypeListShowcase />}
            {lastSelectedItem === 'toggle-button' && <ToggleButtonShowcase />}
          </div>
        </Box>
      </Stack>
    </Stack>
  )
}
